module.exports = __webpack_public_path__ + "static/media/Creditcard.2f495059.svg";